import reducerFactory from '../reducers/index'; 
import thunk from 'redux-thunk'; 
import { createStore, applyMiddleware } from 'redux';

import { composeWithDevTools } from 'redux-devtools-extension';

const appStore = createStore(reducerFactory, composeWithDevTools(applyMiddleware(thunk))); 

export default appStore;